import { Routes } from '@angular/router';
import { autenticato } from '@shared/guardie/autenticato.guard';
import { ArticoliComponent } from '@modules/gestione-articoli/articoli/articoli.component';
import { ArticoloComponent } from '@modules/gestione-articoli/articolo/articolo.component';
import { modificheNonSalvate } from '@shared/guardie/modifiche-non-salvate.guard';

export const articoliRoutes: Routes = [
  {
    path: 'gestione-articoli/articoli',
    canActivate: [autenticato],
    component: ArticoliComponent,
    data: {
      breadcrumb: {
        label: 'Gestione Articoli',
      },
    },
  },
  {
    path: 'gestione-articoli/articoli/nuovo',
    canActivate: [autenticato],
    component: ArticoloComponent,
    canDeactivate: [modificheNonSalvate],
    data: {
      breadcrumb: {
        label: 'Nuovo articolo',
      },
    },
  },
  {
    // Va per ultima: altrimenti prenderebbe anche "nuovo" come identificativo.
    path: 'gestione-articoli/articoli/:id',
    canActivate: [autenticato],
    component: ArticoloComponent,
    canDeactivate: [modificheNonSalvate],
    data: {
      breadcrumb: {
        label: 'Articolo',
      },
    },
  },
];
